import React, { useMemo } from 'react';
import { Avatar } from 'antd';
import { turnManualSelectors } from 'features/turn/services/selectors';
import { IStaffItemData } from 'services/shop/types/staff';
import styled from 'styled-components';
import ModalChooseStaffRef, { useModalChooseStaffRef } from 'widgets/Staff/ModalChooseStaffRef';
type Props = {
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
};
const StaffBoxChange = ({ value, onChange, disabled }: Props) => {
  const addRef = useModalChooseStaffRef();
  const mappingStaffs = turnManualSelectors.mappingStaffs();
  const convertStaffs: IStaffItemData[] = mappingStaffs.map((o) => ({
    id: o.staffId,
    firstName: o.staffName,
    urlImage: o.staffAvatar || '',
  }));

  const activeStaff = useMemo(() => {
    return convertStaffs.find((staff: IStaffItemData) => staff.id === value);
  }, [value, convertStaffs]);
  const onChangeStaff = () =>
    addRef.current?.openWithActive((staff: IStaffItemData) => {
      onChange?.(staff.id);
    }, value);

  return (
    <>
      <Container type='button' onClick={onChangeStaff} disabled={disabled}>
        <Avatar size={40} src={activeStaff?.urlImage || 'A'}>
          {activeStaff?.firstName?.[0] || 'A'}
        </Avatar>
        <span className='staff-name'>{activeStaff?.firstName}</span>
        <div className='icon-change'>{iconChange}</div>
      </Container>
      <ModalChooseStaffRef ref={addRef} v2 staffs={convertStaffs} />
    </>
  );
};

export default StaffBoxChange;
const Container = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  .staff-name {
    color: #1d2129;
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
  &:disabled {
    opacity: 0.5;
  }
`;
const iconChange = (
  <svg xmlns='http://www.w3.org/2000/svg' width='33' height='32' viewBox='0 0 33 32' fill='none'>
    <path
      d='M30.6754 14.9481C30.5966 14.3016 30.0288 13.8443 29.3665 13.9074C28.7199 13.9862 28.2467 14.5696 28.3256 15.2161C28.7199 18.6852 27.5213 22.0754 25.0453 24.551C20.9133 28.6824 14.3842 28.982 9.9053 25.4498H11.3878C12.0344 25.4498 12.5706 24.9137 12.5706 24.2672C12.5706 23.6207 12.0344 23.0846 11.3878 23.0846H6.92462C6.27801 23.0846 5.74181 23.6207 5.74181 24.2672V28.7297C5.74181 29.3762 6.27801 29.9123 6.92462 29.9123C7.57122 29.9123 8.10743 29.3762 8.10743 28.7297V27.0424C10.6623 29.1869 13.8007 30.2592 16.9548 30.2592C20.4875 30.2592 24.0202 28.9189 26.717 26.2225C29.6976 23.2423 31.1328 19.1267 30.6754 14.9481ZM8.8802 8.37264C13.0121 4.24131 19.5413 3.94171 24.0202 7.47384H22.5377C21.8911 7.47384 21.3549 8.00996 21.3549 8.65647C21.3549 9.30297 21.8911 9.8391 22.5377 9.8391H27.0008C27.6474 9.8391 28.1837 9.30297 28.1837 8.65647V4.19401C28.1837 3.5475 27.6474 3.01138 27.0008 3.01138C26.3542 3.01138 25.818 3.5475 25.818 4.19401V5.88123C20.4086 1.33992 12.3025 1.60799 7.20849 6.70118C4.22781 9.68141 2.79267 13.797 3.25002 17.9756C3.3131 18.5748 3.83354 19.0321 4.41706 19.0321C4.46437 19.0321 4.51169 19.0321 4.54323 19.0321C5.18983 18.9532 5.66295 18.3698 5.5841 17.7233C5.18983 14.2543 6.38841 10.864 8.86443 8.38841L8.8802 8.37264Z'
      fill='#232F3E'
    />
  </svg>
);
